<div class="dialog">
    <div class="header">{{data.name[lang] }}</div>
    <gallery [items]="images"></gallery>
</div>